import { type FC } from "react";
import { useDoc } from "use-pouchdb";
import { Link } from "react-router";

import { assertIsItemInfo, type ItemInfo } from "../common/schema";
import { PrimaryImageThumbnail } from "./images";

export type ItemDoc = PouchDB.Core.ExistingDocument<PouchDB.Core.AllDocsMeta> & ItemInfo;

const thumbStyle: React.CSSProperties = {
  width: "50px",
  minHeight: "50px",
  marginRight: "3px",
  backgroundColor: "#ddd",
  flexShrink: 0,
  alignSelf: "stretch",
};

const ItemItemInner: FC<{doc: ItemDoc; displayName: string}> = ({doc, displayName}) => (
  <div data-testid="item-list-row" style={{
    padding:"3px",
    margin:"3px",
    border: "1px solid black",
    display: "flex",
    flexDirection: "row",
    flexGrow: "1",
  }}>
    <PrimaryImageThumbnail itemId={doc._id} iconId={doc.icon_id ?? null} {...(doc.template_id != null ? {templateId: doc.template_id} : {})} style={thumbStyle} />
    <Link to={`/items/${doc._id}`} style={{display: "flex", flexDirection: "column", justifyContent: "space-between", flexShrink: "1"}}>
      <div style={{fontSize: "small", fontFamily: "monospace"}}>{doc._id}</div>
      <div style={{fontFamily: "monospace"}}>{doc.shelcode || "-"}</div>
      <div style={{display: "flex", gap: "4px", alignItems: "center"}}>
        {displayName || <em style={{color: "#aaa"}}>unnamed</em>}
        {doc.qty != null && doc.qty > 1 && <span style={{fontSize: "small", background: "#e8e0f0", borderRadius: "4px", padding: "1px 5px", fontWeight: "bold"}}>×{doc.qty}</span>}
      </div>
    </Link>
  </div>
);

const ItemItemWithTemplate: FC<{doc: ItemDoc; templateId: string}> = ({doc, templateId}) => {
  const { doc: tmpl } = useDoc<Partial<ItemInfo>>(templateId);
  let templateName = "";
  if (tmpl != null) {
    assertIsItemInfo(tmpl);
    templateName = tmpl.name;
  }
  return <ItemItemInner doc={doc} displayName={doc.name || templateName} />;
};

export const ItemItem: FC<{doc: ItemDoc}> = ({doc}) => {
  if (!doc.name && doc.template_id) {
    return <ItemItemWithTemplate doc={doc} templateId={doc.template_id} />;
  }
  return <ItemItemInner doc={doc} displayName={doc.name} />;
};

export const ItemById:FC<{id: string}> = ({id}) => {
  const { doc } = useDoc(id);
  if (doc == null) {
    return <div>Loading</div>;
  } else {
    assertIsItemInfo(doc);
    return <ItemItem doc={doc} />;
  }
};
